import { format } from "prettier/standalone";
import * as prettierPluginBabel from "prettier/plugins/babel";
import * as prettierPluginEstree from "prettier/plugins/estree";

class ObtoMonacoEditorController {
    constructor($scope, $window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document) {
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$compile = $compile;
        this.pageService = pageService;
        this.$http = $http;
        this.$routeParams = $routeParams;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.ribbon = ribbon;
        this.$uibModal = $uibModal;
        this.API = API;
        this.$localstorage = $localstorage;
        this.$log = $log;
        this.$anchorScroll = $anchorScroll;
        this.OB = OB;
        this.$route = $route;
        this.$document = $document;
        this.editor = null;
        this.value = null;
        this.deregister = null;

        // Bind methods to the class instance
        this.render = this.render.bind(this);
        this.setTemplate = this.setTemplate.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
        this.updateLanguage = this.updateLanguage.bind(this);
        this.appMode = this.appMode.bind(this);
    }

    async render(ready = false) {
        let anyUserChanges = '';
        try {
            anyUserChanges = this.editor.getValue();
            this.editor.dispose();
        } catch (e) { }

        // this.$timeout(async () => {
        const monaco = await import('monaco-editor');

        let lang = 'javascript';
        let langCode = 1;

        if (this.values && this.values.hasOwnProperty("mode")) {
            lang = this.getLanguage(this.values.mode);
            langCode = this.values.mode;
        }

        if (this.values.modes && this.values.modes[this.field.name]) {
            lang = this.getLanguage(this.values.modes[this.field.name]);
            langCode = this.values.modes[this.field.name];
        }

        this.editor = monaco.editor.create(document.getElementById("container-" + this.field.name), {
            value: anyUserChanges || this.value,
            language: lang,
            lineNumbers: "off",
            roundedSelection: false,
            scrollBeyondLastLine: false,
            automaticLayout: true,
            readOnly: false,
            theme: "vs-dark",
            fontSize: 12
        });

        const saveCommand = this.editor.createContextKey('saveCommand', false);

        this.editor.getModel().onDidChangeContent(() => {
            this.ngModel.$setViewValue(this.editor.getValue());
            this.value = this.editor.getValue();
            this.change();
        });

        this.editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, () => {
            this.ngModel.$setViewValue(this.editor.getValue());
            this.submitForm();
        }, 'saveCommand');

        saveCommand.set(true);

        this.editor.updateOptions({ lineNumbers: "on" });

        if (ready) {
            this.appMode(this.field.name, langCode);
        }

        this.modified = false;
        // }, 0);
    }

    save() {
        this.ngModel.$setViewValue(this.editor.getValue());
        this.submitForm();
    }

    async setTemplate(name, t) {

        let position = this.editor.getPosition();
        let text = this.editor.getValue();
        let splitedText = text.split("\n");
        let lineContent = splitedText[position.lineNumber - 1];
        let textToInsert = '';

        switch (t) {
            case 1:
                textToInsert = await format(apiQuery, {
                    parser: 'babel',
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    singleQuote: true,
                });
                break;
            case 5:
                textToInsert = await format(deleteCommand, {
                    parser: 'babel',
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    singleQuote: true,
                });
                break;
            case 6:
                textToInsert = await format(findOneCommand, {
                    parser: 'babel',
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    singleQuote: true,
                });
                break;
            case 7:
                textToInsert = await format(updateCommand, {
                    parser: 'babel',
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    singleQuote: true,
                });
                break;
            case 8:
                textToInsert = await format(queueQuery, {
                    parser: 'babel',
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    singleQuote: true,
                });
                break;
            default:
                break;
        }

        splitedText[position.lineNumber - 1] = [lineContent.slice(0, position.column - 1), textToInsert, lineContent.slice(position.column - 1)].join('');
        this.editor.setValue(splitedText.join("\n"));
        this.editor.setPosition(position);
        this.editor.getAction('editor.action.formatDocument').run();
    }

    getLanguage(code) {
        let lang = 'javascript';
        switch (code) {
            case 1:
                lang = 'javascript';
                break;
            case 2:
                lang = 'typescript';
                break;
            case 3:
                lang = 'html';
                break;
            case 4:
                lang = 'css';
                break;
        }

        return lang;
    }

    async updateLanguage(lang) {
        try {
            const monaco = await import('monaco-editor');
            monaco.editor.setModelLanguage(this.editor.getModel(), lang);
        } catch (e) { }
    }

    appMode(fn, formatCode) {
        if (this.values && this.values.modes) {
            this.modifiedFieldValue.modes = {};
            this.modifiedFieldValue.modes = this.values.modes;
        } else {
            this.modifiedFieldValue.modes = {};
        }

        switch (formatCode) {
            case 1:
                this.modifiedFieldValue.modes[this.field.name] = 1;
                this.updateLanguage('javascript');
                break;
            case 2:
                this.modifiedFieldValue.modes[this.field.name] = 1;
                this.updateLanguage('javascript');
                break;
            case 3:
                this.modifiedFieldValue.modes[this.field.name] = 3;
                this.updateLanguage('html');
                break;
            case 4:
                this.modifiedFieldValue.modes[this.field.name] = 4;
                this.updateLanguage('css');
                break;
        }
    }

    maximize() {
        this.editorView = {
            'position': 'fixed',
            'width': '100%',
            'top': '50px',
            'left': '0',
            'z-index': '102',
            'height': '96%'
        };
        this.controlsDistractionFree = {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'z-index': '116',
            'width': '100%',
            'height': '50px'
        };
        this.render(true);
    }

    minimize() {
        this.editorView = { 'height': '700px' };
        this.controlsDistractionFree = {};
        this.outputView = { 'height': '700px' };
        this.render(true);
    }

    reload() {
        this.render(true);
    }

    format() {
        this.editor.getAction('editor.action.formatDocument').run();
    }

    foldAll() {
        this.editor.trigger('fold', 'editor.foldAll');
    }

    unfold() {
        this.editor.trigger('unfold', 'editor.unfoldAll');
    }

    compare() {
        this.open();
    }

    async $onInit() {
        const monaco = await import('monaco-editor');
        const feather = await import("feather-icons");

        monaco.languages.registerDocumentFormattingEditProvider('javascript', {
            async provideDocumentFormattingEdits(model) {
                // const prettier = await import('prettier/standalone');
                // const babylon = await import('prettier/parser-babylon');
                const text = await format(model.getValue(), {
                    parser: 'babel',
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    singleQuote: false,
                });

                return [
                    {
                        range: model.getFullModelRange(),
                        text,
                    },
                ];
            },
        });

        this.deregister = this.$rootScope.$on(`event:editor.refresh.${this.field.name}`, (e, d) => {
            console.log('Received', `event:editor.refresh.${this.field.name}`);
            this.render();
        });

        try {
            feather.replace({
                width: 18,
                height: 18,
            });
        } catch (e) {
            console.log(e);
        }

        this.editorView = { 'height': '700px', 'width': '100%' };

        monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions({
            noSemanticValidation: false,
            noSyntaxValidation: false
        });

        const compilerOptions = {
            allowJs: true,
            allowSyntheticDefaultImports: true,
            alwaysStrict: true,
            jsx: 'React',
            jsxFactory: 'React.createElement',
            noLib: true,
            allowNonTsExtensions: true
        };

        monaco.languages.typescript.typescriptDefaults.setCompilerOptions(compilerOptions);
        monaco.languages.typescript.javascriptDefaults.setCompilerOptions(compilerOptions);

        // Initialize the editor only once on component initialization
        this.render();
    }

    $onDestroy() {
        console.log('onDestroy');
        let anyUserChanges = '';
        this.deregister();
        try {
            anyUserChanges = this.editor.getValue();
            this.editor.dispose();
        } catch (e) { }
    }

    $postLink() {
        console.log('postLink');
        try {
            feather.replace({
                width: 18,
                height: 18,
            });
        } catch (e) {
            console.log(e);
        }

        this.ngModel.$formatters.push((val) => {
            this.value = val;
            this.render(true);
        });
    }

    // $onChanges(changesObj) {
    //     console.log('onChanges', changesObj);
    //     if (changesObj.modified.currenValue == true) {
    //         this.render();
    //     }
    // }
}

ObtoMonacoEditorController.$inject = [
    '$scope',
    '$window',
    '$timeout',
    '$compile',
    'pageService',
    '$http',
    '$routeParams',
    '$rootScope',
    '$location',
    'ribbon',
    '$uibModal',
    'API',
    '$localstorage',
    '$log',
    '$anchorScroll',
    'OB',
    '$route',
    '$document'
];

const ObtoComponentMonacoEditor = {
    selector: "obtoMonacoEditor",
    templateUrl: ['$rootScope', ($rootScope) => {
        return $rootScope.viewFiles + '/monaco-editor.html';
    }],
    require: {
        ngModel: '^ngModel'
    },
    bindings: {
        submitForm: '&',
        change: '&',
        refresh: '&',
        modified: '@',
        open: '&',
        field: '=',
        values: '=',
        modifiedFieldValue: '=',
    },
    controller: ['$scope', '$window', '$timeout', '$compile', 'pageService', '$http', '$routeParams', '$rootScope', '$location', 'ribbon', '$uibModal', 'API', '$localstorage', '$log', '$anchorScroll', 'OB', '$route', '$document', ObtoMonacoEditorController]
};

export default ObtoComponentMonacoEditor;